export default __webpack_public_path__ + "static/media/phone_bg_v2.96bc5384.png";